import {post, get} from '@/utils/http';

export default class Auth {
    /**
     * 用户登录
     * @returns
     */
    static async login(params) {
        return post('/v3/api/login', params);
    }
    /**
     * 获取用户信息
     * @returns
     */
    static async getEnableEmail() {
        return get('/v3/api/getEnableEmail');
    }
    /**
     * 获取用户信息
     * @returns
     */
    static async verifyUserPwdPolicy(userName) {
        return get(`/v3/api/verifyUserPwdPolicy?userId=${userName}`);
    }
    static async verifyUserPwdExpire(userName) {
        return get(`/v3/api/verifyUserPwdExpire?userId=${userName}`);
    }
    /**
     * 发送邮件
     * @returns
     */
    static async sendForgotPwdEmail(email) {
        return post('/v3/api/account/reset-password/init', {strParam: email});
    }
    /**
     * 发送otp
     * @returns
     */
    static async activateToken(params) {
        return get('/v3/api/otp/activateToken' + params);
    }
    static async authToken(params) {
        return get('/v3/api/otp/authToken' + params);
    }
    /**
     * 重置密码
     * @returns
     */
    static async resetPassword(param) {
        return post('/v3/api/account/reset-password/finish', param);
    }
    /**
     * 修改用户头像
     * @returns
     */
    static async updateUserAvatar(params) {
        return post('/v3/services/mfm/api/upload-controller/profile-image-upload', params);
    }
    /**
     * 清除用户头像
     * @returns
     */
    static async clearUserAvatar(params) {
        return post('/v3/api/users/deleteProfileImage', params);
    }
    /**
     * 修改用户密码
     * @returns
     */
    static async updateUserPassword(params) {
        return post('/v3/api/account/change-password', params);
    }

    /**
     * 强制修改用户密码
     * @returns
     */
    static async forceModifyPassword(params) {
        return post('/v3/api/account/force-modify-password', params);
    }


    /**
     * 登录页面获取状态
     * @returns
     */
    static async getAbilityForLoginPage() {
        return get('/v3/api/getAbilityForLoginPage');
    }

    /**
     * 获取账户是否过期
     * @returns
     */
    static async verificationToken(token) {
        return post('/v3/api/verificationToken', token);
    }

    /**
     * @returns
     */
    static async getSmsNoticeContentUrl(token) {
        return post('/v3/services/mrm/api/smsGetNoticeContent/' + token);
    }
}
